function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFlower = function SvgFlower(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25.163 16.28c-3.0865 25.721 10.971 8.149-0.71428-0.081-25.801 12.915 0.67585 14.457-0.38242-0.6083-24.247-11.076-14.876 8.838 0.2374-0.6784-4.5701-26.798-15.113-5.7121 0.67846-0.2375 19.351-19.532-6.8815-12.732 0.60862 0.3825 29.286 2.3429 5.6636-13.318 0.08047 0.7142 18.662 22.714 13.977-4.2285-0.50826 0.5082z",
    strokeLinejoin: "round",
    style: {
      stroke: "var(--primary-color, #000)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 17.04c-7.1921 11.34-5.2666 27.286-5.2666 39",
    strokeWidth: "1px",
    style: {
      stroke: "var(--primary-color, #000)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.544 43.1378s-3.8306 4.6269-9.8624 6.9667c-6.0317 2.3396-11.396 3.0138-11.981 1.5059-0.58491-1.508 3.8306-4.627 9.8624-6.9667s11.981-1.5059 11.981-1.5059z",
    strokeLinejoin: "round",
    style: {
      stroke: "var(--primary-color, #000)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.3794 32.34s2.0325 5.6526 6.9118 9.9009c4.8793 4.2483 9.6958 6.7033 10.758 5.4835 1.0621-1.2198-2.0325-5.6526-6.9118-9.9009-4.8793-4.2483-10.758-5.4835-10.758-5.4835z",
    strokeLinejoin: "round",
    style: {
      stroke: "var(--primary-color, #000)"
    }
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlower, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Flower.067ee722.svg";
export { ForwardRef as ReactComponent };